webpackJsonp([162108450479614],{

/***/ 3999:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ }),

/***/ 4000:
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(92);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/**
	 * The base implementation of `_.toNumber` which doesn't ensure correct
	 * conversions of binary, hexadecimal, or octal string values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 */
	function baseToNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  return +value;
	}
	
	module.exports = baseToNumber;


/***/ }),

/***/ 4008:
/***/ (function(module, exports, __webpack_require__) {

	var baseToNumber = __webpack_require__(4000),
	    baseToString = __webpack_require__(392);
	
	/**
	 * Creates a function that performs a mathematical operation on two values.
	 *
	 * @private
	 * @param {Function} operator The function to perform the operation.
	 * @param {number} [defaultValue] The value used for `undefined` arguments.
	 * @returns {Function} Returns the new mathematical operation function.
	 */
	function createMathOperation(operator, defaultValue) {
	  return function(value, other) {
	    var result;
	    if (value === undefined && other === undefined) {
	      return defaultValue;
	    }
	    if (value !== undefined) {
	      result = value;
	    }
	    if (other !== undefined) {
	      if (result === undefined) {
	        return other;
	      }
	      if (typeof value == 'string' || typeof other == 'string') {
	        value = baseToString(value);
	        other = baseToString(other);
	      } else {
	        value = baseToNumber(value);
	        other = baseToNumber(other);
	      }
	      result = operator(value, other);
	    }
	    return result;
	  };
	}
	
	module.exports = createMathOperation;


/***/ }),

/***/ 4009:
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(719),
	    toNumber = __webpack_require__(207),
	    toString = __webpack_require__(144);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Creates a function like `_.round`.
	 *
	 * @private
	 * @param {string} methodName The name of the `Math` method to use when rounding.
	 * @returns {Function} Returns the new round function.
	 */
	function createRound(methodName) {
	  var func = Math[methodName];
	  return function(number, precision) {
	    number = toNumber(number);
	    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	    if (precision) {
	      // Shift with exponential notation to avoid floating-point issues.
	      // See [MDN](https://mdn.io/round#Examples) for more details.
	      var pair = (toString(number) + 'e').split('e'),
	          value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	      pair = (toString(value) + 'e').split('e');
	      return +(pair[0] + 'e' + (+pair[1] - precision));
	    }
	    return func(number);
	  };
	}
	
	module.exports = createRound;


/***/ }),

/***/ 4021:
/***/ (function(module, exports, __webpack_require__) {

	var createMathOperation = __webpack_require__(4008);
	
	/**
	 * Divide two numbers.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.7.0
	 * @category Math
	 * @param {number} dividend The first number in a division.
	 * @param {number} divisor The second number in a division.
	 * @returns {number} Returns the quotient.
	 * @example
	 *
	 * _.divide(6, 4);
	 * // => 1.5
	 */
	var divide = createMathOperation(function(dividend, divisor) {
	  return dividend / divisor;
	}, 1);
	
	module.exports = divide;


/***/ }),

/***/ 4028:
/***/ (function(module, exports, __webpack_require__) {

	var createRound = __webpack_require__(4009);
	
	/**
	 * Computes `number` rounded to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Math
	 * @param {number} number The number to round.
	 * @param {number} [precision=0] The precision to round to.
	 * @returns {number} Returns the rounded number.
	 * @example
	 *
	 * _.round(4.006);
	 * // => 4
	 *
	 * _.round(4.006, 2);
	 * // => 4.01
	 *
	 * _.round(4060, -2);
	 * // => 4100
	 */
	var round = createRound('round');
	
	module.exports = round;


/***/ }),

/***/ 4029:
/***/ (function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(3999),
	    identity = __webpack_require__(141);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(207);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(718);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),

/***/ 4047:
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(2)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.CircularProgressbar=t(require("react")):e.CircularProgressbar=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.i=function(e){return e},t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=7)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=r(6),c=n(u),l=r(4),p=n(l),f=function(e){function t(e){o(this,t);var r=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.state={percentage:e.initialAnimation?0:e.percentage},r}return i(t,e),s(t,[{key:"componentDidMount",value:function(){var e=this;this.props.initialAnimation&&(this.initialTimeout=setTimeout(function(){e.requestAnimationFrame=window.requestAnimationFrame(function(){e.setState({percentage:e.props.percentage})})},0))}},{key:"componentWillReceiveProps",value:function(e){this.setState({percentage:e.percentage})}},{key:"componentWillUnmount",value:function(){clearTimeout(this.initialTimeout),window.cancelAnimationFrame(this.requestAnimationFrame)}},{key:"getBackgroundPadding",value:function(){return this.props.background?null==this.props.backgroundPadding?this.props.strokeWidth:this.props.backgroundPadding:0}},{key:"getPathDescription",value:function(){var e=this.getPathRadius(),t=this.props.counterClockwise?1:0;return"\n      M 50,50\n      m 0,-"+e+"\n      a "+e+","+e+" "+t+" 1 1 0,"+2*e+"\n      a "+e+","+e+" "+t+" 1 1 0,-"+2*e+"\n    "}},{key:"getPathStyles",value:function(){var e=2*Math.PI*this.getPathRadius(),t=Math.min(Math.max(this.state.percentage,0),100),r=(100-t)/100*e;return{strokeDasharray:e+"px "+e+"px",strokeDashoffset:(this.props.counterClockwise?-r:r)+"px"}}},{key:"getPathRadius",value:function(){return 50-this.props.strokeWidth/2-this.getBackgroundPadding()}},{key:"render",value:function(){var e=this.props,t=(e.percentage,e.className),r=e.classes,n=e.styles,o=e.strokeWidth,a=e.text,i=this.getPathDescription();return c.default.createElement("svg",{className:r.root+" "+t,style:n.root,viewBox:"0 0 100 100"},this.props.background?c.default.createElement("circle",{className:r.background,style:n.background,cx:50,cy:50,r:50}):null,c.default.createElement("path",{className:r.trail,style:n.trail,d:i,strokeWidth:o,fillOpacity:0}),c.default.createElement("path",{className:r.path,d:i,strokeWidth:o,fillOpacity:0,style:Object.assign({},n.path,this.getPathStyles())}),a?c.default.createElement("text",{className:r.text,style:n.text,x:50,y:50},a):null)}}]),t}(c.default.Component);f.propTypes={percentage:p.default.number.isRequired,className:p.default.string,text:p.default.string,classes:p.default.objectOf(p.default.string),styles:p.default.objectOf(p.default.object),strokeWidth:p.default.number,background:p.default.bool,backgroundPadding:p.default.number,initialAnimation:p.default.bool,counterClockwise:p.default.bool},f.defaultProps={strokeWidth:8,className:"",text:null,classes:{root:"CircularProgressbar",trail:"CircularProgressbar-trail",path:"CircularProgressbar-path",text:"CircularProgressbar-text",background:"CircularProgressbar-background"},styles:{root:{},trail:{},path:{},text:{},background:{}},background:!1,backgroundPadding:null,initialAnimation:!1,counterClockwise:!1},t.default=f},function(e,t,r){"use strict";function n(e){return function(){return e}}var o=function(){};o.thatReturns=n,o.thatReturnsFalse=n(!1),o.thatReturnsTrue=n(!0),o.thatReturnsNull=n(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},e.exports=o},function(e,t,r){"use strict";function n(e,t,r,n,a,i,s,u){if(o(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[r,n,a,i,s,u],p=0;c=new Error(t.replace(/%s/g,function(){return l[p++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(1),o=r(2),a=r(5);e.exports=function(){function e(e,t,r,n,i,s){s!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){e.exports=r(3)()},function(e,t,r){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,r){t.exports=e},function(e,t,r){e.exports=r(0)}])});

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _progress, _value;
	
	  return {
	    container: {
	      width: '100%',
	      overflow: 'hidden',
	      backgroundColor: '#ddd',
	      margin: '3px 0'
	    },
	    progress: (_progress = {
	      color: '#fff',
	      fontWeight: 400,
	      height: 25,
	      display: 'flex',
	      alignItems: 'center'
	    }, _progress[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em',
	      height: 21
	    }, _progress),
	    value: (_value = {
	      position: 'absolute',
	      textShadow: '1px 1px 1px #666',
	      padding: '0 5px',
	      textTransform: 'uppercase'
	    }, _value[theme.breakpoints.down('xs')] = {
	      textShadow: '1px 1px 1px #666'
	    }, _value)
	  };
	};
	
	var ProgressBar = function (_React$Component) {
	  _inherits(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProgressBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      value: 0
	    }, _this.componentDidMount = function () {
	      var value = _this.props.value;
	
	      if (value) {
	        return _this.setState({ value: value });
	      }
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      var value = nextProps.value;
	
	      if (value !== _this.props.value) {
	        return _this.setState({ value: value });
	      }
	    }, _this.toPercentage = function (value) {
	      if (typeof value === 'number') {
	        return value + '%';
	      }
	    }, _this.getColor = function (value) {
	      var theme = _this.props.theme;
	
	      var color = void 0;
	
	      if (value < 60) color = theme.palette.error.main;else if (value >= 60 && value < 80) color = theme.palette.warning;else if (value >= 80) color = '#56af78';
	
	      return color;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        label = _props.label;
	    var state = this.state;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: classes.container },
	      _react2.default.createElement(
	        _Typography2.default,
	        {
	          className: classes.progress,
	          style: {
	            width: this.toPercentage(state.value),
	            backgroundColor: this.getColor(state.value)
	          }
	        },
	        _react2.default.createElement(
	          'span',
	          { className: classes.value },
	          label,
	          ' ',
	          this.toPercentage(state.value)
	        )
	      )
	    );
	  };
	
	  return ProgressBar;
	}(_react2.default.Component);
	
	ProgressBar.defaultProps = {
	  value: 0
	};
	
	ProgressBar.propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.number
	};
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(ProgressBar);
	module.exports = exports['default'];

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Divider = __webpack_require__(210);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _reactCircularProgressbar = __webpack_require__(4047);
	
	var _reactCircularProgressbar2 = _interopRequireDefault(_reactCircularProgressbar);
	
	var _startCase = __webpack_require__(339);
	
	var _startCase2 = _interopRequireDefault(_startCase);
	
	var _ProgressBar = __webpack_require__(936);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _root, _header, _pros, _cons, _button;
	
	  return {
	    root: (_root = {
	      border: '1px solid ' + theme.palette.borders.cloudier,
	      borderTop: '3px solid #824160',
	      padding: 20
	    }, _root[theme.breakpoints.down('xs')] = {
	      marginBottom: 20
	    }, _root),
	    header: (_header = {
	      color: '#333',
	      textTransform: 'none'
	    }, _header[theme.breakpoints.down('xs')] = {
	      fontSize: '1.4em',
	      fontWeight: 700
	    }, _header),
	    progressWrapper: {
	      margin: 'auto',
	      marginBottom: 20,
	      width: 150
	    },
	    progressCircle: {
	      '&:hover': {
	        transform: 'scale(1.15)'
	      }
	    },
	    stats: {},
	    pros: (_pros = {}, _pros[theme.breakpoints.down('xs')] = {
	      fontSize: '1.4em'
	    }, _pros),
	    cons: (_cons = {}, _cons[theme.breakpoints.down('xs')] = {
	      fontSize: '1.4em'
	    }, _cons),
	    ul: {
	      fontSize: '0.9em'
	    },
	    button: (_button = {
	      color: '#fff',
	      borderRadius: 0,
	      backgroundColor: theme.palette.button.callToAction,
	      '&:hover': {
	        opacity: 0.8,
	        backgroundColor: theme.palette.button.callToAction
	      }
	    }, _button[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em'
	    }, _button)
	  };
	};
	
	var Summary = function Summary(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      header = _ref.header,
	      pros = _ref.pros,
	      cons = _ref.cons,
	      statistics = _ref.statistics,
	      value = _ref.value,
	      to = _ref.to;
	
	  var color = void 0;
	
	  if (value < 60) color = theme.palette.error.main;else if (value >= 60 && value < 80) color = theme.palette.warning;else if (value >= 80) color = '#2cad35';
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    _react2.default.createElement(
	      _Typography2.default,
	      { align: 'center', variant: 'headline', className: classes.header },
	      header
	    ),
	    _react2.default.createElement(_Divider2.default, {
	      style: { margin: '20px 0', color: theme.palette.borders.cloudier }
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { spacing: 24, container: true },
	      _react2.default.createElement(
	        _Grid2.default,
	        { xs: 12, sm: 6, item: true },
	        _react2.default.createElement(
	          'div',
	          { className: classes.progressWrapper },
	          _react2.default.createElement(_reactCircularProgressbar2.default, {
	            percentage: value,
	            text: value + '%',
	            className: classes.progressCircle,
	            styles: {
	              path: {
	                stroke: color
	              },
	              text: {
	                fontSize: '1em',
	                fill: color
	              }
	            },
	            initialAnimation: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.stats },
	          Object.keys(statistics).map(function (key) {
	            return _react2.default.createElement(_ProgressBar2.default, {
	              key: key,
	              label: (0, _startCase2.default)(key),
	              value: statistics[key]
	            });
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { xs: 12, sm: 6, item: true },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: 15 } },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                className: classes.pros,
	                variant: 'title',
	                style: {
	                  fontWeight: 700,
	                  color: '#4ab673',
	                  textTransform: 'uppercase'
	                }
	              },
	              'Pros:'
	            ),
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                style: { paddingLeft: 15, listStyleType: 'circle' },
	                className: classes.ul,
	                component: 'ul'
	              },
	              pros.map(function (line) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: line },
	                  line
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: 15 } },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                className: classes.cons,
	                variant: 'title',
	                style: {
	                  fontWeight: 700,
	                  color: theme.palette.error.main,
	                  textTransform: 'uppercase'
	                }
	              },
	              'Cons:'
	            ),
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                style: { paddingLeft: 15, listStyleType: 'circle' },
	                className: classes.ul,
	                component: 'ul'
	              },
	              cons.map(function (line) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: line },
	                  line
	                );
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Divider2.default, {
	      style: { margin: '20px 0', color: theme.palette.borders.cloudier }
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'a',
	        { href: to },
	        _react2.default.createElement(
	          _Button2.default,
	          { variant: 'raised', size: 'large', className: classes.button },
	          'GO TO THE OFFICIAL WEBSITE'
	        )
	      )
	    )
	  );
	};
	
	Summary.defaultProps = {
	  pros: [],
	  cons: [],
	  statistics: {
	    effectiveness: 0.0,
	    valueForMoney: 0.0,
	    testimonials: 0.0,
	    company: 0.0
	  }
	};
	
	Summary.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  pros: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
	  cons: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
	  statistics: _propTypes2.default.shape({
	    effectiveness: _propTypes2.default.number.isRequired,
	    valueForMoney: _propTypes2.default.number.isRequired,
	    testimonials: _propTypes2.default.number.isRequired,
	    company: _propTypes2.default.number.isRequired
	  }).isRequired,
	  to: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(Summary);
	module.exports = exports['default'];

/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _sum = __webpack_require__(4029);
	
	var _sum2 = _interopRequireDefault(_sum);
	
	var _divide = __webpack_require__(4021);
	
	var _divide2 = _interopRequireDefault(_divide);
	
	var _toNumber = __webpack_require__(207);
	
	var _toNumber2 = _interopRequireDefault(_toNumber);
	
	var _round = __webpack_require__(4028);
	
	var _round2 = _interopRequireDefault(_round);
	
	var _ShareBar = __webpack_require__(368);
	
	var _ShareBar2 = _interopRequireDefault(_ShareBar);
	
	var _Meta = __webpack_require__(48);
	
	var _Summary = __webpack_require__(937);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _theme = __webpack_require__(213);
	
	var _formatDate2 = __webpack_require__(133);
	
	var _formatDate3 = _interopRequireDefault(_formatDate2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _extends2, _title, _titleSlogan, _formatDate, _authorWrapper;
	
	  return {
	    content: _extends({}, (0, _theme.pageStyle)(theme), (_extends2 = {
	      margin: 0,
	      padding: 10,
	      width: 700
	    }, _extends2[theme.breakpoints.down('sm')] = {
	      width: '90%'
	    }, _extends2)),
	    title: (_title = {
	      textTransform: 'none',
	      textAlign: 'center',
	      fontWeight: 600,
	      color: theme.palette.text.main,
	      padding: '8px 0'
	    }, _title[theme.breakpoints.down('xs')] = {
	      fontSize: '1.5em'
	    }, _title),
	    titleSlogan: (_titleSlogan = {
	      textAlign: 'center',
	      color: theme.palette.text.light
	    }, _titleSlogan[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em'
	    }, _titleSlogan),
	    formatDate: (_formatDate = {
	      color: theme.palette.text.light,
	      marginBottom: 25,
	      textAlign: 'center'
	    }, _formatDate[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em'
	    }, _formatDate),
	    authorWrapper: (_authorWrapper = {
	      padding: 15,
	      color: theme.palette.text.soft
	    }, _authorWrapper[theme.breakpoints.down('xs')] = {
	      fontSize: '1em'
	    }, _authorWrapper),
	    author: {
	      fontWeight: 500,
	      color: theme.palette.primary.main,
	      '&:hover': {
	        opacity: 1
	      }
	    }
	  };
	};
	
	var ReviewTemplate = function ReviewTemplate(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      data = _ref.data,
	      pathContext = _ref.pathContext;
	  var reviewBody = pathContext.reviewBody;
	  var review = data.markdownRemark,
	      authorNode = data.authorNode,
	      file = data.file;
	
	  var baseUrl = 'https://healthfulinspired.com';
	
	  // const datePublished = new Date(review.frontmatter.date).toISOString()
	  var datePublished = new Date().toISOString();
	  var dateModified = file.modifiedTime;
	
	  var authorComponent = null;
	
	  if (authorNode) {
	    authorComponent = _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: authorNode.fields.slug, className: classes.author },
	      review.frontmatter.originalAuthor
	    );
	  } else {
	    authorComponent = _react2.default.createElement(
	      'span',
	      null,
	      review.frontmatter.originalAuthor
	    );
	  }
	
	  var statistics = {
	    effectiveness: (0, _toNumber2.default)(review.frontmatter.effectivenessRating),
	    valueForMoney: (0, _toNumber2.default)(review.frontmatter.valueForMoneyRating),
	    testimonials: (0, _toNumber2.default)(review.frontmatter.testimonialsRating),
	    company: (0, _toNumber2.default)(review.frontmatter.companyRating)
	  };
	
	  var summaryRating = (0, _round2.default)((0, _divide2.default)((0, _sum2.default)(Object.keys(statistics).map(function (key) {
	    return statistics[key];
	  })), 4));
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    {
	      id: 'reviewPage',
	      spacing: 24,
	      justify: 'center',
	      alignItems: 'center',
	      style: { padding: '20px 0' },
	      container: true
	    },
	    _react2.default.createElement(_Meta.ArticleMeta, {
	      title: review.frontmatter.uiTitle,
	      shortDescription: review.frontmatter.shortDescription,
	      thumbnail: review.frontmatter.thumbnail,
	      genre: 'health',
	      tags: review.frontmatter.tags,
	      wordCount: review.wordCount.words,
	      datePublished: datePublished,
	      dateModified: dateModified,
	      articleBody: reviewBody,
	      excerpt: review.excerpt,
	      path: review.fields.slug
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { className: classes.content, item: true },
	      _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'display1', className: classes.title },
	        review.frontmatter.uiTitle
	      ),
	      review.frontmatter.uiTitleSlogan && _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'subheading', className: classes.titleSlogan },
	        review.frontmatter.uiTitleSlogan
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { align: 'center', className: classes.formatDate },
	        (0, _formatDate3.default)(new Date()),
	        ' ',
	        '\u2022',
	        ' ',
	        review.timeToRead,
	        ' min read'
	      ),
	      _react2.default.createElement(_Summary2.default, {
	        header: review.frontmatter.productName + ' by ' + review.frontmatter.productCreator,
	        value: summaryRating,
	        statistics: statistics,
	        pros: review.frontmatter.pros,
	        cons: review.frontmatter.cons,
	        to: review.frontmatter.landingUrl
	      }),
	      _react2.default.createElement(_ShareBar2.default, {
	        baseUrl: baseUrl,
	        url: '' + baseUrl + review.fields.slug,
	        thumbnail: review.frontmatter.thumbnail,
	        title: review.frontmatter.title,
	        excerpt: review.excerpt,
	        tags: review.frontmatter.tags
	      }),
	      _react2.default.createElement(
	        _Typography2.default,
	        { align: 'center', className: classes.authorWrapper },
	        'Reviewed by: ',
	        authorComponent
	      ),
	      _react2.default.createElement('div', {
	        className: 'markdown',
	        dangerouslySetInnerHTML: { __html: review.html }
	      })
	    ),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n        .markdown {\n          color: ' + theme.palette.text.main + ';\n        }\n        h1, h2, h3, h4, h5, h6 {\n          line-height: 1em;\n        }\n        h1 {\n          padding: 20px 0;\n        }\n        @media (max-width: 600px) {\n          .markdown h1, h2, h3 {\n            font-size: 1.4em;\n          }\n        }\n      '
	    )
	  );
	};
	
	ReviewTemplate.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.shape({
	    reviewBody: _propTypes2.default.string.isRequired
	  }).isRequired
	
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(ReviewTemplate);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-review-js-2994c5dbcb2c49a75787.js